import React, { useState } from 'react';
import { Grid, TextField, IconButton, Chip, Menu, MenuItem, Divider } from '@mui/material';
// import PlayCircleFilledIcon from '@mui/icons-material.PlayCircleFilled';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';

const UGLComponent = ({ selectedServer, demo, gameFallback, showFrame }) => {
  const [playerId, setPlayerId] = useState("1");
  const [playerName, setPlayerName] = useState("quickfire");
  const [discoToggle, setDiscoToggle] = useState(false);
  const [ingameInterfaceToggle, setIngameInterfaceToggle] = useState(false);
  const [showPlaycheckToggle, setShowPlaycheckToggle] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentURL, setCurrentURL] = useState('');

  const openMenu = (event, url) => {
    setAnchorEl(event.currentTarget);
    setCurrentURL(url);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const openTab = (url) => {
    window.open(url, '_blank');
  };

  // const openFrame = (url = "") => {
  //   showFrame(url);
  // };

  // Helper functions for URL parts
  const getGameId = () => selectedServer?.game?.launchID || gameFallback;
  const getCasinoId = () => selectedServer?.serverId || '';
  const getAuthToken = () => selectedServer?.authToken || '';
  const getLanguageCode = () => selectedServer?.language?.shortCode || 'en';
  const getLobby = () => selectedServer?.lobby?.name || '';
  const getIsUAT = () => selectedServer?.site?.code === "uat" ? "uat" : "";

  const gamesys = selectedServer?.operatorId === 47200;
  const playtech = selectedServer?.operatorId === 51399;
  const gamePlatform = selectedServer?.game?.platform === "HTML5 - Desktop" ? "desktop" : "mobile";
  const gamePlatformPlaytech = selectedServer?.game?.platform === "HTML5 - Desktop" ? "web" : "mobile";

  const showPlaycheck = showPlaycheckToggle ? '&showva=help,playcheck' : '';
  const discoEnabled = discoToggle ? '&apicommsenabled=true' : '';
  const ingameInterface = ingameInterfaceToggle ? '&interfaceurl=https://quickfireportal.gameassists.co.uk/examples/igi.html' : '';


  const getSiteId = (siteName) => {
    const map = {
      njs: 67, mis: 67, pas: 67, ons: 67, cts: 67,
      njp: 71, mip: 71, pap: 71, ctp: 71,
      onp: 96,
    };
    return map[siteName?.toLowerCase()] || '';
  };
  const siteId = getSiteId(selectedServer?.site?.name);
  // Build the Real and Demo URLs
  const uglReal = playtech
    ? `https://gamelauncher${getIsUAT()}.gameassists.co.uk/launcher/?game=${getGameId()}&username=qf_int_gbp_01&casino=${getLobby()}&clientplatform=${gamePlatformPlaytech}&clienttype=1&real=1&currency=GBP&language=${getLanguageCode()}&token=${getAuthToken()}`
    : gamesys
      ? `https://gamelauncher${getIsUAT()}.gameassists.co.uk/launcher/gamesys?sound=true&gameKey=${getGameId()}&currency=GBP&playMode=CASH&runtimeGroup=LIVE:MicroGaming&website=${getLobby()}&platform=${gamePlatform}&sessionKey=${getAuthToken()}&language=${getLanguageCode()}&playerId=${playerId}&homeButton=true&chat=true&country=GB&playerName=${playerName}&homePos=none&balancePos=right`
      : `https://redirector${siteId}.valueadditional.com/Casino/Default.aspx?applicationid=4123&serverid=${getCasinoId()}&gameid=${getGameId()}&authtoken=${getAuthToken()}&ul=${getLanguageCode()}${showPlaycheck}${discoEnabled}${ingameInterface}`;

  const uglDemo = playtech
    ? `https://gamelauncher${getIsUAT()}.gameassists.co.uk/launcher/?game=${getGameId()}&username=qf_int_gbp_01&casino=${getLobby()}&clientplatform=${gamePlatformPlaytech}&clienttype=1&real=0&currency=GBP&language=${getLanguageCode()}`
    : gamesys
      ? `https://gamelauncher${getIsUAT()}.gameassists.co.uk/launcher/gamesys?sound=true&gameKey=${getGameId()}&currency=GBP&playMode=GUEST&runtimeGroup=LIVE:MicroGaming&website=${getLobby()}&platform=${gamePlatform}&language=${getLanguageCode()}&playerId=${playerId}&homeButton=true&chat=true&country=GB&playerName=${playerName}&homePos=none&balancePos=right`
      : `https://redirector${siteId}.valueadditional.com/Casino/Default.aspx?applicationid=4123&serverid=${getCasinoId()}&gameid=${getGameId()}&playmode=demo&ul=${getLanguageCode()}${showPlaycheck}${discoEnabled}${ingameInterface}`;

  return (
    <div>
      {/* Toggles */}
      <Grid container alignItems="center">
        <Grid item xs>
          <i>Generate <b>Universal Game Launcher</b> links below.</i>
        </Grid>
        <Chip
          label="Show Playcheck & Help"
          color={showPlaycheckToggle ? "primary" : "default"}
          onClick={() => setShowPlaycheckToggle(!showPlaycheckToggle)}
        />
        <Chip
          label="DISCO"
          color={discoToggle ? "primary" : "default"}
          onClick={() => setDiscoToggle(!discoToggle)}
        />
        <Chip
          label="Ingame Interface"
          color={ingameInterfaceToggle ? "primary" : "default"}
          onClick={() => setIngameInterfaceToggle(!ingameInterfaceToggle)}
        />
      </Grid>

      {/* Real Link */}
      <Grid container spacing={2} style={{ marginTop: '16px' }}>
        <Grid item xs={12}>
          <TextField
            label="Real"
            fullWidth
            value={uglReal}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <>
                  <IconButton onClick={(e) => openMenu(e, uglReal)}>
                    <OpenInNewIcon />
                  </IconButton>
                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
                    <MenuItem onClick={() => { openTab(currentURL); closeMenu(); }}>
                      <OpenInNewIcon /> Open in New Tab
                    </MenuItem>
                    {/* <MenuItem onClick={() => { openFrame(currentURL); closeMenu(); }}>
                      <OpenInBrowserIcon /> Open in iFrame
                    </MenuItem> */}
                  </Menu>
                </>
              ),
            }}
            helperText="Launch link for live gameplay"
          />
        </Grid>
      </Grid>

      {/* Demo Link */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Demo"
            fullWidth
            value={uglDemo}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <>
                  <IconButton onClick={(e) => openMenu(e, uglDemo)}>
                    <OpenInNewIcon />
                  </IconButton>
                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
                    <MenuItem onClick={() => { openTab(currentURL); closeMenu(); }}>
                      <OpenInNewIcon /> Open in New Tab
                    </MenuItem>
                    {/* <MenuItem onClick={() => { openFrame(currentURL); closeMenu(); }}>
                      <OpenInBrowserIcon /> Open in iFrame
                    </MenuItem> */}
                  </Menu>
                </>
              ),
            }}
            helperText="Launch link for demo gameplay"
          />
        </Grid>
      </Grid>

      {/* Divider and Additional Fields for Gamesys */}
      {gamesys && (
        <>
          <Divider style={{ margin: '16px 0' }} />
          <Grid container spacing={2}>
            <Grid item md={6}>
              <TextField
                label="Player ID"
                fullWidth
                value={playerId}
                onChange={(e) => setPlayerId(e.target.value)}
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                label="Player Name"
                fullWidth
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
              />
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

export default UGLComponent;
